// js/src/modules/accordion.js

export default class Accordion {
    constructor(selector) {
        this.items = document.querySelectorAll(selector);

        if (!this.items.length) {
            return;
        }

        this.init();
    }

    init() {
        this.items.forEach((button) => {
            const panel = button.parentElement.nextElementSibling;

            button.setAttribute("aria-expanded", "false");

            if (panel) {
                panel.hidden = true;
            }

            button.addEventListener("click", () => {
                this.toggle(button, panel);
            });
        });
    }

    toggle(button, panel) {
        const expanded = button.getAttribute("aria-expanded") === "true";

        button.setAttribute("aria-expanded", String(!expanded));

        if (panel) {
            panel.hidden = expanded;
        }
    }
}